import { SimpleAnswerEnum } from '../../enums/entity.enum';
import {
  DealDynamicEnum,
  DealTypeSecondaryEnum,
} from '../../enums/secondary.enum';
import { AksiaRoleEnum, SourceDealEnum } from '../../enums/closedEnd.enum';
import { SecondaryAsset } from '../entities/entities.model';
import { StoreModelType, StoreModelDate } from '@aksia/infrastructure';

export class SecondaryDetails {
  id: number | undefined = undefined;
  fundId: number | undefined = undefined;

  //#region Historical Info

  fundNameAsset: string | undefined = undefined;

  //#endregion

  //#region Decision Dates

  bidsOutstanding: SimpleAnswerEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  targetICDate: Date | undefined = undefined;

  //#endregion

  //#region Categorization Factors

  dealType: DealTypeSecondaryEnum | undefined = undefined;
  //carryReset?: SimpleAnswerEnum = undefined;
  sourceDeal: SourceDealEnum | undefined = undefined;
  sourceContact: string | undefined;
  aksiaRole: AksiaRoleEnum | undefined = undefined;
  dealDynamic: DealDynamicEnum | undefined = undefined;

  //#endregion

  //#region Key Terms

  @StoreModelType(() => StoreModelDate)
  firstRoundBidDate: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  finalBidDate: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  expectedDealClose: Date | undefined = undefined;

  finalTransactionPrice: number | undefined = undefined;
  aksiaProposedPriceRange: string | undefined = undefined;
  proposedBindingBid: number | undefined = undefined;
  managementCompanyName: string | undefined = undefined;
  fundsCompany: string | undefined = undefined;
  discountGuidance: string | undefined = undefined;
  actionItems: string | undefined = undefined;
  updateText: string | undefined = undefined;

  //#endregion

  //#region Assets

  @StoreModelType(() => SecondaryAsset)
  assets: Array<SecondaryAsset> | undefined = undefined;

  //#endregion

  //#region GP Led Details

  subsequentFundsInvesting: SimpleAnswerEnum | undefined = undefined;

  //#endregion
}
